import React from 'react';
import '../../styles/establishment/establishmentHeader.css'; // using premade styles from EstablishmentsDashboardHeading
import '../../styles/establishment/establishmentDashboard.css';
import {Panel, Accordion} from 'react-bootstrap';
import InfoIcon from '../icons/InfoIcon';


export default function BulkTransferHeading() {
  return (
  <div  id="establishment-dashboard-page">
    <div id="establishment-dashboard-header">
      <div
        id="establishment-dashboard-instructions-container"
        className="alert alert-info col-xs-12 non-mobile">
        <div id="establishment-dashboard-instructions">
          <div className="first-line"><InfoIcon/> Instructions for Transferring Establishments</div>
          <ul>
            <li>
            Requestor's email must match the domain (e.g., @mail.com) of the original administrator</li>
            <li>
              Please provide at least 2 of the following search criteria: Address, EIN #, and/or Establishment Name to validate your association with at least one of the user's establishments</li>
            <li>
              Up to 500 establishments may be selected for Bulk Transfer at a time
            </li>
            <li>
            User verification search is used to validate a user's association with at least one of the owner's establishments. Upon successful validation, users will have the option to transfer all establishments associated with the owner
            </li>
          </ul>
        </div>
      </div>
      <Accordion defaultActiveKey="1">
        <Panel
          header="Instructions for Transferring Establishments"
          eventKey="1"
          id="establishment-dashboard-instructions-container"
          className="alert alert-info col-xs-12 mobile">
          <div id="establishment-dashboard-instructions">
            <ul>
              <li>
              Requestor's email must match the domain (e.g., @mail.com) of the original administrator</li>
              <li>
              Please provide at least 2 of the following search criteria: Address, EIN #, and/or Establishment Name to validate your association with at least one of the user's establishments.              </li>
              <li>
              Up to 500 establishments may be selected for Bulk Transfer at a time.
            </li>
            </ul>
          </div>
        </Panel>
      </Accordion>
    </div>
  </div>
  )
}



/** WEBPACK FOOTER **
 ** ./src/components/bulkTransfer/BulkTransferHeading.js
 **/